module.exports = __webpack_public_path__ + "img/post1.819d1190.png";